import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { LeafAccordion } from '@cigna/leaf-web/lib/wc';
import '@cigna/leaf-web/lib/wc/components/accordion/accordion';

@Component({
  selector: 'cigna-leaf-accordion',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // note: some minor custom styling is needed to get around ::slotted component leaf css rules that don't work with our wrapper
  // .leaf-c-inner-divider ::slotted(leaf-accordion-item:not(first-child))
  styles: `
    :host ::ng-deep cigna-leaf-accordion-item {
      display: block;
    }
    :host[ng-reflect-has-divider="true"] ::ng-deep cigna-leaf-accordion-item {
      border-top: var(--leaf-border-width-default) var(--leaf-border-style-default) var(--leaf-color-border-default);
    }
    :host[ng-reflect-has-divider="true"] ::ng-deep cigna-leaf-accordion-item:first-child {
      border-top: 0;
    }
  `,
  template: `
    <leaf-accordion [hasDivider]="hasDivider"
      ><ng-content></ng-content
    ></leaf-accordion>
  `,
})
export class CignaLeafAccordionComponent {
  @Input() hasDivider: LeafAccordion['hasDivider'];
}
